import styles from "./CountedProgress.module.css";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

type CountedProgressProps = {
  max: number;
  count: number;
  label: string;
};

function CountedProgress({ max, count, label }: CountedProgressProps) {
  return (
    <div className={styles["root"]}>
      <div className={styles["top"]}>
        <FixaText textStyle="Heading.XS" tagName="h2">
          {label}
        </FixaText>
        <FixaText textStyle="Heading.XS">
          {count}/{max}
        </FixaText>
      </div>
      <div className={styles["barWrapper"]}>
        <div
          className={styles["bar"]}
          style={{
            width:
              max === 0
                ? "100%"
                : `${Math.max(Math.min(count / max, 1), 0) * 100}%`,
          }}
        />
      </div>
    </div>
  );
}

export default CountedProgress;
